import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Layout from "./layout/layout"
import Login from "./pages/login";
import NotFound from './pages/notfound'
import Dashboard from "./pages/dashboardrevamp";
import Booking from "./pages/booking/booking";
import ShipperAdvice from "./pages/shipperadvice/shipperadvicetabs";
import AddressLabel from "./pages/addresslabel/addresslabel";
import Loadsheet from "./pages/loadsheet/loadsheet";
import Userguide from "./pages/userguide/userguide";
import BookingSummary from "./pages/bookingsummary/bookingsummary";
import Tracking from "./pages/tracking/tracking";
import Tracking_2 from "./pages/tracking_2/trackingtab";
import BulkBooking from "./pages/bulkbooking/bulkbooking";
import { useEffect } from "react";
import SubAccount from "./pages/subaccount/subaccount";
import User from "./pages/user/user";
import Location from "./pages/location/location";
import ReversePickup from "./pages/reversepickup/reversepickup";
import VoidConsignments from "./pages/cnvoid/voidconsignments";
import Complaint from "./pages/complaint/complaint";
import InternationalBooking from "./pages/Internationalbooking/Internationalbooking";
import QSR from "./pages/qsr/qsr";
import CustomerSummary from "./pages/customersummary/customersummary";
import ConsigneeProfile from "./pages/consigneeprofile/consigneeprofile";
import ReversePickupReport from "./pages/reversepickupreport/reversepickupreport";
import PaymentInstrumentReport from "./pages/paymentinstrument/paymentinstrument";
import PaymentInstrumentDetailReport from "./pages/paymentinstrumentdetail/paymentinstrumentdetail";
import Tariff from "./pages/tariff/tariff";
import InternationalAddressLabel from "./pages/internationaladdresslabel/internationaladdresslabel";
import SearchLoadsheets from "./pages/searchloadsheets/searchloadsheets";
import ChangePassword from "./pages/changepassword";
import InvoiceSummary from "./pages/invoicesummary/invoicesummary";
import ForgetPassword from "./pages/forgetpassword";
import ComplaintReport from "./pages/complaintreport/complaintreport";
import ServiceRequest from "./pages/servicerequest/servicerequest";
import LocationShops from "./pages/locationshops/locationshops";
import KPIBurstTime from "./pages/KPIBurstTime/kpibursttime";
import OldPortal from "./pages/oldportal";
import UserManagement from "./pages/usermanagement/usermanagement";
import CustomerDetail from "./pages/customerdetail/customerdetail";
import WeightDiscrepency from "./pages/weightdiscrepency/weightdiscrepency";
import DarazBulkBooking from "./pages/darazbulkbooking/darazbulkbooking";
import DarazLoadsheet from "./pages/darazLoadsheet/darazLoadsheet";
import RetailBooking from "./pages/retailbooking/retailbooking";
import RetailLoadsheet from "./pages/retailloadsheet/retailloadsheet";
import RetailSearchLoadsheet from "./pages/retailsearchloadsheet/retailsearchloadsheet";
import PrePayments from "./pages/prepayments/prepayments";
import CustomerInfo from "./pages/customerinfo/customerinfo";
import RetailBulkBooking from "./pages/retailbulkbooking/retailbulkbooking";
import UserCreation from "./pages/usercreation/usercreation";
import PortalBanner from "./pages/dynamicbanner/dynamicbanner";
import Osansa from "./pages/osansa/osansa";
import VoidConsignmentReport from "./pages/voidconsignment/voidconsignment";
import MapICCID from "./pages/mapICCID/mapiccid";
import QsrOnicReport from "./pages/qsr-onic/qsr-onic";
import BulkAddressLabel from "./pages/addresslabel/bulklabel";


const App = () => {
    return <Router basename="cplight">
        <Switch>
            <Route path="/login" component={Login} exact />
            <Route path="/forgetpassword" component={ForgetPassword} exact />
            <Route path="/changepassword" component={ChangePassword} exact />
            <Route>
                <Layout>
                    <Switch>
                        <Route path="/" exact component={Dashboard} />
                        <Route path="/userguide" component={Userguide} />
                        <Route path="/booking" component={Booking} />
                        <Route path="/internationalbooking" component={InternationalBooking} />
                        <Route path="/reversepickup" component={ReversePickup} />
                        <Route path="/bulkbooking">
                            <BulkBooking />
                        </Route>
                        <Route path="/mapiccid">
                            <MapICCID />
                        </Route>
                        <Route path="/retailbulkbooking">
                            <RetailBulkBooking/>
                        </Route>
                        <Route path="/shipperadvice" component={ShipperAdvice} />
                        <Route path="/addresslabel" component={AddressLabel} />
                        <Route path="/loadsheet" component={Loadsheet} />
                        <Route path="/bookingsummary" component={BookingSummary} />
                        <Route path="/tracking" component={Tracking} />
                        <Route path="/tracking_2" component={Tracking_2} />
                        <Route path="/subaccount" component={SubAccount} />
                        <Route path="/user" component={User} />
                        <Route path="/location" component={Location} />
                        <Route path="/voidConsignments" component={VoidConsignments} />
                        <Route path="/complaint" component={Complaint} />
                        <Route path="/qsr" component={QSR} />
                        <Route path="/customersummary" component={CustomerSummary} />
                        <Route path="/consigneeprofile" component={ConsigneeProfile} />
                        <Route path="/reversepickupreport" component={ReversePickupReport} />
                        <Route path="/paymentinstrument" component={PaymentInstrumentReport} />
                        <Route path="/paymentinstrumentdetail" component={PaymentInstrumentDetailReport} />
                        <Route path="/tariff" component={Tariff} />
                        <Route path="/internationaladdresslabel" component={InternationalAddressLabel} />
                        <Route path="/searchloadsheets" component={SearchLoadsheets} />
                        <Route path="/invoicesummary" component={InvoiceSummary} />
                        <Route path="/complaintreport" component={ComplaintReport} />
                        <Route path="/servicerequest" component={ServiceRequest} />
                        <Route path="/locationshops" component={LocationShops} />
                        <Route path="/kpibursttime" component={KPIBurstTime} />
                        <Route path="/oldportal" component={OldPortal} />
                        <Route path="/usermanagement" component={UserManagement} />
                        <Route path="/customerdetail" component={CustomerDetail} />
                        <Route path="/voidconsignment" component={VoidConsignmentReport} />
                        <Route path="/weightdiscrepency" component={WeightDiscrepency} />
                        <Route path="/darazBulkBooking">
                            <DarazBulkBooking />
                        </Route>
                        <Route path="/darazLoadsheet" component={DarazLoadsheet} />
                        <Route path="/retailbooking" component={RetailBooking} />
                        <Route path="/retailloadsheet" component={RetailLoadsheet} />
                        <Route path="/retailsearchloadsheet" component={RetailSearchLoadsheet} />
                        <Route path="/premayments" component={PrePayments} />
                        <Route path="/customerinfo" component={CustomerInfo} />
                        <Route path="/createuser" component={UserCreation} />
                        <Route path="/portalbanner" component={PortalBanner} />
                        <Route path="/consignmentosansa" component={Osansa} />
                        <Route path="/qsronicreport" component={QsrOnicReport} />
                        <Route path="/bulkaddresslabel" component={BulkAddressLabel} />
                        <Route component={NotFound} />
                    </Switch>
                </Layout>
            </Route>
        </Switch>
    </Router>
}

export default App;